import React, { useState } from "react";
import { Button, Image, Row, Col, Form } from "react-bootstrap";
import { NewSelectBoxInput } from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import OfflineEvent from "./OfflineEvent";
import OnlineEvent from "./OnlineEvent";
import { getCountries } from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import { FormControl, Select, InputLabel, makeStyles } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const AddNewEvent = () => {
  const classes = useStyles();
  //state
  const [selectedTab, setSelectedTab] = useState(1);
  const handleTab = (e) => {
    setSelectedTab(e);
  };
  const [checked, setChecked] = useState(false);
  const toggleFunction = (e) => {
    setChecked({ checked: !checked.checked });
  };
  const [state, setState] = useState({
    country: "",
    restaurant: "",
    state: "",
    City: "",
  });
  const selecthandleChange = (e) => {
    setState({ [e.target.name]: e.target.value });
  };
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">Add New Event</div>
              </div>
              {/* <Row className="pb-4">
                <Col lg={8}>
                  <Form.Group>
                    <NewSelectBoxInput
                      selectLabel="Country"
                      name="country"
                      value={state.country}
                      onChange={selecthandleChange}
                      getCountries={getCountries}
                      en={en}
                    />
                  </Form.Group>
                </Col>
                <Col lg={8}>
                  <Row>
                    <Col md={6}>
                      <Form.Group>
                        <FormControl
                          variant="outlined"
                          className={classes.formControl}
                        >
                          <InputLabel htmlFor="outlined-State">
                            State
                          </InputLabel>
                          <Select
                            value={state.state}
                            onChange={selecthandleChange}
                            label="State"
                            inputProps={{
                              name: "state",
                              id: "outlined-State",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            <option value={"State"}>State</option>
                          </Select>
                        </FormControl>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <FormControl
                          variant="outlined"
                          className={classes.formControl}
                        >
                          <InputLabel htmlFor="outlined-City">City</InputLabel>
                          <Select
                            value={state.city}
                            onChange={selecthandleChange}
                            label="City"
                            inputProps={{
                              name: "city",
                              id: "outlined-City",
                            }}
                            IconComponent={KeyboardArrowDownIcon}
                          >
                            <option value={"City"}>City</option>
                          </Select>
                        </FormControl>
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>
                <Col lg={8}>
                  <Form.Group>
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <InputLabel htmlFor="outlined-Select Restaurant">
                        Select Restaurant
                      </InputLabel>
                      <Select
                        value={state.restaurant}
                        onChange={selecthandleChange}
                        label="Select Restaurant"
                        inputProps={{
                          name: "restaurant",
                          id: "outlined-restaurant",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        <option value={"Restaurant"}>Restaurant</option>
                      </Select>
                    </FormControl>
                  </Form.Group>
                </Col>
              </Row> */}
              <div className="f20-700 mb-4">Event Type</div>
              <div className="d-flex align-items-start">
                <Button
                  variant="link"
                  className={`enAddOffersOPtion ${
                    selectedTab === 1 ? "active" : ""
                  }`}
                  onClick={(e) => handleTab(1)}
                >
                  <Image
                    src={
                      selectedTab === 1
                        ? require("../../../../../assets/images/UserManagement/offlineActiveOffer.svg")
                        : require("../../../../../assets/images/UserManagement/offlineDeactiveOffer.svg")
                    }
                    alt="View"
                    title="View"
                    fluid
                    className="ml-3"
                  />
                  <span className="active f12-400 d-block w-100 mb-2">
                    Offline Event
                  </span>
                  <span className="w-100 f9-400 d-block">
                    (Note: Events are in a physical venue and you can even
                    accept RSVP)
                  </span>
                </Button>
                <Button
                  variant="link"
                  className={`enAddOffersOPtion ml-3 ${
                    selectedTab === 2 ? "active" : ""
                  }`}
                  onClick={(e) => handleTab(2)}
                >
                  <Image
                    src={
                      selectedTab === 2
                        ? require("../../../../../assets/images/UserManagement/onlineActiveOffer.svg")
                        : require("../../../../../assets/images/UserManagement/onlineDeactiveOffer.svg")
                    }
                    alt="View"
                    title="View"
                    fluid
                    className="ml-3"
                  />
                  <span className="active f12-400 d-block w-100 mb-2">
                    Online Event
                  </span>
                  <span className="w-100 f9-400 d-block">
                    (Note: Events are online you need a link stored at the time
                    Event creation You can accept RSVP for the event)
                  </span>
                </Button>
              </div>
              <hr />
              {selectedTab === 1 && <OfflineEvent />}
              {selectedTab === 2 && <OnlineEvent />}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default AddNewEvent;
